<template>
  <div class="app-container">
    <BjRouteTabs :route-list="BUSINESS_WAREHOUSE_EFFICIENCY" />
    <div class="width-full flex-spacebetween" style="padding: 10px 6%;">
      <!-- <el-date-picker
        v-model="lineChart.queryParamsTime_pay"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="datetimerange"
        :picker-options="$pickerOptions()"
        align="right"
        :start-placeholder="$t('BusinessPurchaseOrder.header.startData')"
        :end-placeholder="$t('BusinessPurchaseOrder.header.endData')"
        :default-time="Date.now() - 30 * 24 * 3600 * 1000"
      >
      </el-date-picker> -->
      <el-date-picker v-model="lineChart.queryParamsTime_pay" :picker-options="pickerOptions" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" :placeholder="$t('chooseText')" />
    </div>
    <el-empty v-if="lineChart.lineChartData.series[0].data.length==0" description="No Data"></el-empty>
    <LineChart v-else :chart-data="lineChart.lineChartData" />
  </div>
</template>
<script>
import { BUSINESS_WAREHOUSE_EFFICIENCY } from '@/utils/constants';
import LineChart from './LineChart1';
import { afterApi } from '@/api';
import moment from 'moment';
const echarts = require('echarts/lib/echarts');

const attackSourcesColor = [
    new echarts.graphic.LinearGradient(0, 1, 1, 1, [
      { offset: 0, color: '#EB3B5A' },
      { offset: 1, color: '#FE9C5A' }
    ]),
    new echarts.graphic.LinearGradient(0, 1, 1, 1, [
      { offset: 0, color: '#FA8231' },
      { offset: 1, color: '#FFD14C' }
    ]),
    new echarts.graphic.LinearGradient(0, 1, 1, 1, [
      { offset: 0, color: '#F7B731' },
      { offset: 1, color: '#FFEE96' }
    ]),
    new echarts.graphic.LinearGradient(0, 1, 1, 1, [
      { offset: 0, color: 'rgb(76,150,80,1)' },
      { offset: 1, color: 'rgb(76,150,80,.6)' }
    ]),
    new echarts.graphic.LinearGradient(0, 1, 1, 1, [
      { offset: 0, color: 'rgb(57,89,255,1)' },
      { offset: 1, color: 'rgb(46,200,207,1)' }
    ])
];

export default {
  name: 'BusinessOrderTimelinessAverage',
  components: { LineChart },
  data() {
    return {
      BUSINESS_WAREHOUSE_EFFICIENCY,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 24 * 3600 * 1000;
        },
      },
      lineChart: {
        tabData: '0',
        lineChartData: {
            series: [{
                  name: '值',
                  type: 'bar',
                  zlevel: 1,
                  itemStyle: {
                      normal: {
                          barBorderRadius: 30,
                          color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                              offset: 0,
                              color: 'rgb(57,89,255,1)'
                          }, {
                              offset: 1,
                              color: 'rgb(46,200,207,1)'
                          }]),
                      },
                  },
                  barWidth: 14,
                  data: []
              },
              {
                  name: '背景',
                  type: 'bar',
                  barWidth: 14,
                  barGap: '-100%',
                  data: [],
                  itemStyle: {
                      normal: {
                          color: 'rgba(24,31,68,0.2)',
                          barBorderRadius: 30,
                      }
                  },
              },
          ],
          yAxis: [{
              type: 'category',
              inverse: true,
              axisLabel: {
                  show: true,
                  textStyle: {
                      color: '#000'
                  },
              },
              splitLine: {
                  show: false
              },
              axisTick: {
                  show: false
              },
              axisLine: {
                  show: false
              },
              data: []
          }, {
              type: 'category',
              inverse: false,
              axisTick: 'none',
              axisLine: 'none',
              show: true,
              axisLabel: {
                  textStyle: {
                      color: '#ffffff',
                      fontSize: '12'
                  },
              },
              data: []
          }]
        },
        queryParamsTime_pay: moment(new Date() - 24 * 3600 * 1000).format('YYYY-MM-DD'),
        creationStartDate: moment(new Date() - 24 * 3600 * 1000).format('YYYY-MM-DD') + ' 00:00:00',
        creationEndDate: moment(new Date() - 24 * 3600 * 1000).format('YYYY-MM-DD') + ' 00:00:00',
        // creationStartDate: moment(new Date() - 30 * 24 * 3600 * 1000).format('YYYY-MM-DD HH:mm:ss'),
        // creationEndDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      }
    };
  },
  watch: {
    'lineChart.queryParamsTime_pay': {
      immediate: false,
      handler(v) {
        this.lineChart.creationStartDate = v + ' 00:00:00';
        this.lineChart.creationEndDate = v + ' 00:00:00';
        this.getOrderReport();
        // if (v) {
        //   this.lineChart.creationStartDate = (v || [])[0];
        //   this.lineChart.creationEndDate = (v || [])[1];
        //   this.getOrderReport();
        // } else {
        //   this.lineChart.creationStartDate = moment(new Date() - 30 * 24 * 3600 * 1000).format('YYYY-MM-DD HH:mm:ss');
        //   this.lineChart.creationEndDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        //   this.getOrderReport();
        // }
      }
    },
    // 'lineChart.tabData': {
    //   handler(v) {
    //     this.getOrderReport();
    //   }
    // }
  },
  mounted() {
    this.getOrderReport();
  },
  methods: {
    // 根据年和周数转换为年月日
    getDateFromYearAndWeek(year, week) {
      const start = moment().year(year).isoWeek(week - 1).isoWeekday(0).format('YYYY-MM-DD');
      const end = moment().year(year).isoWeek(week).isoWeekday(0).format('YYYY-MM-DD');
      return `${start} to\n ${end}`;
    },
    attackSourcesDataFmt(sData) {
        var sss = [];
        sData.forEach(function(item, i) {
          const itemStyle = {
            color: attackSourcesColor[i % 5]
            // color: i > 3 ? attackSourcesColor[3] : attackSourcesColor[i]
          };
          sss.push({
            value: item,
            itemStyle: itemStyle
          });
        });
        return sss;
    },

    // 清空 报表 操作
    emptyDataReport() {
      this.lineChart.lineChartData.yAxis[0].data = [];
      this.lineChart.lineChartData.yAxis[1].data = [];
      this.lineChart.lineChartData.series[0].data = [];
      this.lineChart.lineChartData.series[1].data = [];
    },
    // 获取报表
    getOrderReport() {
      const data = {
        creationStartDate: this.lineChart.creationStartDate,
        creationEndDate: this.lineChart.creationEndDate,
        reportType: this.lineChart.tabData
      };
      afterApi.getSelectPickerKPI(data).then(res => {
        if (!res.length) {
          this.emptyDataReport();
        } else {
          this.emptyDataReport();
          const result = res.reduce((acc, cur) => {
            const index = acc.findIndex(item => item.picker === cur.picker);
            if (index === -1) {
              acc.push(cur);
            } else {
              acc[index].orderCount += cur.orderCount;
            }
            return acc;
          }, []);
          this.lineChart.lineChartData.yAxis[0].data = result.map(item => item.picker);
          this.lineChart.lineChartData.yAxis[1].data = result.sort((a, b) => { return b.orderCount - a.orderCount; }).map(item => item.orderCount);
          this.lineChart.lineChartData.series[0].data = this.attackSourcesDataFmt(result.sort((a, b) => { return b.orderCount - a.orderCount; }).map(item => item.orderCount));
          this.lineChart.lineChartData.series[1].data = Array(result.length).fill(Math.max(...result.map((value) => value.orderCount)));
        }
      });
    },
  },
};
</script>
